<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="flex w-full bg-img">
    <div
      class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center"
    >
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="@/assets/images/pages/forgot-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center"
            >
              <div class="p-8">
                - شماره تماس تلفنی:
                <a href="tel:02126401398"  class="underline">
                  <span class="link-txt">
                    <i class="fa fa-phone"></i>
                    <span class="link-ext"></span>
                    <span class="txt">02126401398</span>
                  </span>
                </a>
                <br />
                - شماره تماس واتساپ:
                <a href="#" @click="openWhatsapp" class="underline">
                  09014114232
                </a>
                
                <router-link to="/merchant/merchants">
                    aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: "",
    };
  },
  methods: {
    openWhatsapp(e) {
      //e.preventDefault();
      if (
        navigator.userAgent.toLowerCase().indexOf("android") > -1 ||
        navigator.userAgent.toLowerCase().indexOf("ios") > -1
      ) {
        window.location = "whatsapp://send?phone=989014114232";
      } else {
        //window.open('whatsapp://send?phone=989014114232', '_blank');
        window.open(
          "https://web.whatsapp.com/send?phone=989014114232",
          "_blank"
        );
      }
    },
  },
};
</script>
